module.exports = __webpack_public_path__ + "img/SMRAT-300x300.3c3727d2.png";